export default __webpack_public_path__ + "static/media/brochure-eng.e0bfc6a2.pdf";